import {
  mapFileTreeType,
  PermissionNameUnionType,
  useFindAllLegalFilesSuspense,
} from '@api';
import {
  CreateFolderModal,
  FileTree,
  UploadFileModal,
  useFileTreeMethods,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';

export const LegalFileTree: React.FC = () => {
  const { hasPermission } = usePermissionContext<PermissionNameUnionType>();

  const userCanWriteLegalDocuments = hasPermission({
    permission: 'ORGANIZATION_DOCUMENTS',
    action: 'WRITE',
  });

  const {
    data,
    isFetching: isFetchingTreeItems,
    refetch: refetchFiles,
  } = useFindAllLegalFilesSuspense({
    query: {
      select: (response) => mapFileTreeType(response.data),
    },
  });

  const { files, locationId, isInitiallyExpanded } = data;

  const { treeMethods, createFolderModalMethods, uploadFileModalMethods } =
    useFileTreeMethods({
      files,
      locationId,
      isInitiallyExpanded,
      isFetchingTreeItems,
      refetchFiles,
    });

  return (
    <>
      <FileTree {...treeMethods} canWrite={userCanWriteLegalDocuments} />
      <CreateFolderModal {...createFolderModalMethods} />
      <UploadFileModal {...uploadFileModalMethods} />
    </>
  );
};
